import { Calendar, CloudUploadIcon, Eye, FileText, Filter, Search, X } from "lucide-react";
import { Layout } from "./Layout";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList } from "./ui/breadcrumb";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { useState, useEffect, useContext } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";
import { DataTable } from "./DataTable";
import { AppContext } from "../src/App";
import { PaginationCustom } from "./ui/pagination-custom";
import { Badge } from "./ui/badge";
import {

  endOfMonth,
  format,
  startOfMonth,
  subDays,
  endOfYesterday,
  startOfYesterday 
} from "date-fns"
import { buildQuery, formatDate, getLastWeekRange, toSQLDateTime } from "@/Utils/helpers";
import { apiClient } from "@/Utils/apiClient";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/routes/config";
const CHART_TYPES = ['CSC', 'DLS'] as const;
export interface Run {
  id: string;
  run_id: string;
  batch_name: string;
  run_type: string;
  chart_type: string;
  start_datetime: string;
  end_datetime?: string | null;
  total_time_ms?: string | null;
  average_time_ms?: number | null;
  total_charts: number;
  successful_charts: number;
  failed_charts: number;
  run_status: string;
  errors: any[] | null;
  detailed_log: any[] | null;
  created_at: string;
  updated_at: string;
}
interface ChartDetail{
  log_date:Date;
  total_charts:number
  updated_charts:number
  pending_charts:number
  no_action_charts:number
}
interface ChartData{
  data:{
    todayActivity:{
      total_charts:number;
      updated_charts:number;
      pending_charts:number;
      no_action_charts:number;

    },
    historyData:ChartDetail[]
  },
  pagination:{
    currentPage:number;
    limit:number
    totalCount:number
    totalPages:number
  }
}

export function KanTimeDetails() {
  const { setCurrentView,setSelectedHarvestRunData,orgConfig} = useContext(AppContext);
  const navigate = useNavigate();
 
  const [selectedChartTypes, setSelectedChartTypes] = useState<Set<string>>(new Set());
  // const [runType, setRunType] = useState('all');
  // const [runStatus, setRunStatus] = useState('all');
  // const [searchTerm, setSearchTerm] = useState('');
  const [chartData,setChartData]=useState<ChartData>()

  // for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const {token}=useAuth()
  // data range
const now = new Date();

const startOfDay = (d: Date) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

const endOfDay = (d: Date) => {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
};

  const [dateRange, setDateRange] = useState({
           from: startOfDay(subDays(now, 7)),
           to: endOfDay(now),
  });

const dateRangeValue = [
  {
    label: "Last 24 Hours",
    value: {
      type: "rolling",
      from: new Date(now.getTime() - 24 * 60 * 60 * 1000),
      to: now,
    },
  },
  {
    label: "Last 7 Days",
    value: {
      type: "fixed",
      from: startOfDay(subDays(now, 7)),
      to: endOfDay(now),
    },
  },
  {
    label: "Last 30 Days",
    value: {
      type: "fixed",
      from: startOfDay(subDays(now, 30)),
      to: endOfDay(now),
    },
  },
  {
    label: "All Time",
    value: {
      type: "fixed",
      from: startOfDay(new Date(0)),
      to: endOfDay(now),
    },
  },
];

  
 const [selectedLabel, setSelectedLabel] = useState("Last 7 Days");
//  const [dateRange, setDateRange] = useState(dateRangeValue[1]?.value);

const handleDateRangeChange = (label: string) => {
  const range = dateRangeValue.find((r) => r.label === label);
  if (!range) return;

  let from, to;

  if (range.value.type === "rolling") {
    // Last 24 hours → keep real time
    from = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    to = new Date();
  } else {
    // Fixed ranges → full day timestamps
    from = range.value.from;
    to = range.value.to;
  }

  setDateRange({ from, to });
  setSelectedLabel(label);
  setCurrentPage(1);
};

  const fetchData=async()=>{
    try{
      const queryParams={
        fromDate: formatDate(dateRange.from),
        toDate: formatDate(dateRange.to),
        page:currentPage,
        limit:itemsPerPage

      }
     const query=buildQuery(queryParams,{
      fromDate:"fromDate",
      toDate:"toDate",
      page:"page",
      limit:"limit"
     })
      const response=await apiClient(`audits/charts/kantime/update/logs?${query}`,{
        method:"GET",
        token

      })
      const result=await response.json();
      setChartData(result);


    }
    catch(error:any){
      if(error.status<500)
      {
        toast.error(error.message)

      }
      else{
      toast.error("Something went wrong please try again")
      }

    }
  }
  useEffect(()=>{
    fetchData()

  },[dateRange.from,dateRange.to,currentPage])
  const toggleChartType = (chartType: string) => {
    const newSelected = new Set(selectedChartTypes);
    if (newSelected.has(chartType)) {
      newSelected.delete(chartType);
    } else {
      newSelected.add(chartType);
    }
    setSelectedChartTypes(newSelected);
    setCurrentPage(1);
  };

  const clearChartTypeFilters = () => {
    setSelectedChartTypes(new Set());
    setCurrentPage(1);
  };
  //pagination
  const totalPages = chartData?.pagination.totalPages || Math.ceil(chartData?.data?.historyData?.length||0 / itemsPerPage);
  const totalItems = chartData?.pagination?.totalCount || chartData?.data?.historyData.length||0;

  // Fix: Use currentPage.currentPage instead of currentPage
  const startIndex = (currentPage - 1) * itemsPerPage;
  // const paginatedData = mockData?.slice(startIndex, startIndex + itemsPerPage);
  const onPageChange = (page: number) => {
    setCurrentPage(page);
  };

  // Row Click
  const handleRowClick = (item: any) => {
    // setSelectedChart(item);
    // setShowChartLogs(true);
  };
  // style
  const thStyle="text-[14px] font-inter font-semibold leading-[100%] tracking-[-0.5%] whitespace-normal break-words uppercase text-[#758195]";
  const tdStyle="font-inter text-sm text-gray-700"

  return (
    <Layout>
      <div>
        <div className="p-6 space-y-6">
          <div className="mb-4">
            <div className="mb-4">
              <Breadcrumb>
                <BreadcrumbList>
                  <BreadcrumbItem>
                    <BreadcrumbLink href="#" className="text-gray-600 hover:text-gray-900"><div className="flex items-center gap-2"><CloudUploadIcon className="w-4 h-4" />{`${orgConfig?.name} Status`}</div></BreadcrumbLink>
                  </BreadcrumbItem>

                </BreadcrumbList>
              </Breadcrumb>
            </div>
            {/* KanTime Run Log page Header*/}
            <div>
              <div className="mb-1">
                <h1 className="text-2xl font-semibold text-gray-900">{`Updated ${orgConfig?.name} Charts Status`}</h1>
              </div>
              <div>
                <p className="text-gray-600">{`Monitor automated ${orgConfig?.name} updates`}</p>
              </div>

            </div>
          </div>
          {/* Today Metrics*/}
          <Card className="bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-200 gap-2">
            <CardHeader className="py-2 px-2">
              <CardTitle className="pb-1 text-blue-900 text-sm">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <Calendar className="w-3 h-3 text-gray-500" />
                    <p className="text-sm">Today's Activity</p>
                  </div>
                  <div>
                    <Badge
                      variant="outline"
                      className="ml-auto text-xs text-blue-700 border-blue-300 py-0 px-1.5 h-4"
                    >
                      {format(new Date(), "MMM dd")}

                    </Badge>
                  </div>
                </div>
              </CardTitle>

            </CardHeader>
            <CardContent className="p-0 m-0">
              <div className="grid grid-rows-1 grid-cols-6  ">

                <div className="col-start-2 text-center">
                  <p className="text-xs text-purple-700 font-medium leading-tight">No of Charts</p>
                  <p className="text-base font-bold text-purple-900 leading-none">{chartData?.data?.todayActivity?.total_charts}</p>
                </div>

                <div className="text-center">
                  <p className="text-xs text-purple-700 font-medium leading-tight">Updated</p>
                  <p className="text-base font-bold text-purple-900 leading-none">{chartData?.data?.todayActivity?.updated_charts}</p>
                  </div>
                <div className="text-center">
                  <p className="text-xs text-purple-700 font-medium leading-tight">Pending</p>
                  <p className="text-base font-bold text-purple-900 leading-none">{chartData?.data?.todayActivity?.pending_charts}</p>
                  </div>
                <div className="text-center">
                  <p className="text-xs text-purple-700 font-medium leading-tight">No Action</p>
                  <p className="text-base font-bold text-purple-900 leading-none">{chartData?.data?.todayActivity?.no_action_charts}</p>
                  
                  </div>
              </div>
            </CardContent>
          </Card>


          {/* Runs Table */}
          <Card className="rounded-2xl shadow-sm">
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle>Updated History</CardTitle>
                <div>
                  <div className="flex items-center gap-2 ">
                    <Calendar className="w-5 h-5 text-gray-500" />
                    <Select
                     value={selectedLabel}
                      onValueChange={(value) => handleDateRangeChange(value)}
>
                      <SelectTrigger className="w-36">
                       <SelectValue />
                      </SelectTrigger>
                        <SelectContent>
                          {dateRangeValue.map((value, index) => (
                          <SelectItem key={index} value={value.label}>
                           {value.label}
                         </SelectItem>
                         ))}
                      </SelectContent>
                    </Select>

                  </div>
                </div>
              </div>

            </CardHeader>
            <CardContent>
              
                <div>
                  <DataTable<ChartDetail>
                    data={chartData?.data?.historyData??[]}
                     onRowClick={(row:ChartDetail,index:number) => {
  
  setSelectedHarvestRunData(row);
  setCurrentView('kanTime-runLog');
  navigate(ROUTES.kanTimeLog,{
    state : {kantime : row}
  })
}}
                    columns={[
                      {
                        key: "Date",
                        header: "Updated Date",
                        headerClassName:thStyle,
                        cellClassName: tdStyle,
                        render: (chart) => new Date(chart.log_date).toLocaleDateString("en-US"),
                      },
                      {
                        key: "start_datetime",
                        header: "Updated Time",
                        render: (chart) =>
                          chart.log_date
                            ? new Date(chart.log_date).toLocaleTimeString("en-US")
                            : "-",
                        headerClassName:thStyle,
                        cellClassName: tdStyle,
                      },
                      {
                        key: "total_charts",
                        header: "No of Charts",
                        render: (chart) => chart.total_charts,
                        headerClassName:thStyle,
                        cellClassName: tdStyle,
                      },
                      {
                        key: "updated_charts",
                        header: "Updated",
                        render: (chart) => chart.updated_charts || 0,
                         headerClassName:thStyle,
                        cellClassName: tdStyle,
                      },
                      {
                        key: "pending_charts",
                        header: "Pending",
                        render: (chart) => chart.pending_charts || 0,
                       headerClassName:thStyle,
                        cellClassName: tdStyle,
                      },
                      {
                        key: "no_action_charts",
                        header: "No Action",
                        render: (chart) => chart.no_action_charts || 0,
                         headerClassName:thStyle,
                        cellClassName: tdStyle,
                      },
                      {
                        key: "Action",
                        header: "Action",
                         headerClassName:thStyle,
                        render: (chart) => (
                          <div className="flex items-center gap-1">
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                // handleRunClick(chart);
                                setSelectedHarvestRunData(chart)
                                setCurrentView('kanTime-runLog')
                                 navigate(ROUTES.kanTimeLog,{
                               state : {kantime : chart}
                              })

                              }}
                              title="View Details"
                            >
                              <Eye className="w-4 h-4" />
                            </Button>
                          </div>
                        ),
                      }
                    ]}
                  />
                  {totalPages > 1 && (
                    <div className="px-6 py-4 border-t bg-gray-50">
                      <div className="flex justify-between items-center">
                        {/* <span className="text-sm text-gray-600">
                                          Showing {totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} results
                                        </span> */}

                        <PaginationCustom
                          currentPage={currentPage}
                          totalPages={totalPages}
                          totalItems={totalItems}
                          itemsPerPage={itemsPerPage}
                          onPageChange={onPageChange}
                          onItemsPerPageChange={(newItemsPerPage) => {
                            setCurrentPage(1) // Reset page to 1
                          }}
                        // showPageSizeSelector={false}  
                        // showItemCount={false}         
                        />
                      </div>
                    </div>



                  )}

                </div>
              
            </CardContent>
          </Card>
        </div>
      </div>

    </Layout>
  );
}